export default __webpack_public_path__ + "static/media/522.a1e3873f.jpg";